import { use } from "react";
import { WebSocketContext } from "./WebSocketContext";
import type { WebSocketContextType } from "./types";

export function useWebSocketContext(): WebSocketContextType {
	const context = use(WebSocketContext);

	if (context === undefined) throw new Error("useWebSocketContext must be used within a WebSocketProvider");

	return context;
}
